var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27415 2.0475C8.32317 1.96226 9.21875 0.521729 10.8362 0.521729C12.4357 0.521729 12.5471 2.15831 12.5471 2.70384C12.5471 4.18699 12.0258 6.55236 10.4797 10.4563C10.2569 11.0146 10.2881 11.3002 10.3148 11.3598C10.3238 11.3598 10.453 11.4323 10.8362 11.4323H19.391C21.2758 11.4323 22.813 12.8984 22.813 14.7054V15.3234C23.2897 15.8093 23.9536 16.7128 23.9536 17.9786C23.9536 18.9077 23.5927 19.6408 23.214 20.1607C23.5927 20.6764 23.9536 21.4137 23.9536 22.3428C23.9536 23.6044 23.2897 24.5121 22.813 24.998V25.616C22.813 27.4188 21.2758 28.8892 19.391 28.8892H6.27356C2.81598 28.8892 0 26.1956 0 22.8884L0 15.7965C0 14.3815 0.450022 13.0262 1.30105 11.8755L8.27415 2.0475Z",
    fill: "#21BB71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.f144b6dc.svg";
export { ForwardRef as ReactComponent };